module.exports = __webpack_public_path__ + "img/wonky-chilli.5c584045.png";